import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { formatNumber } from 'src/utils/helperFunctions';

const NumberCell: FC<React.PropsWithChildren<GridCellProps>> = ({ dataItem, colSpan, columnIndex, isSelected, ariaColumnIndex, className, style, field, format }) => (
  <td
    colSpan={colSpan}
    className={className}
    role="gridcell"
    aria-colindex={ariaColumnIndex}
    aria-selected={isSelected}
    data-grid-col-index={columnIndex}
    style={{ ...style, textAlign: 'right' }}
  >
    {formatNumber(dataItem[field], format)}
  </td>
);

export default NumberCell;
